import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import toast, { Toaster } from "react-hot-toast";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Header } from "antd/lib/layout/layout";
import PreferencesNav from "./PreferencesNav";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import AddIcon from "@mui/icons-material/Add";
// import { CKEditor } from "@ckeditor/ckeditor5-react";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import {
  termsConditionList1,
  addTermsCondition,
  updateTermsCondition,
  termsConditionUUID1,
} from "../../services/index";
import { searchForMatch } from "../utils/textUtils";

const TermsConditionList = () => {
  let navigate = useNavigate();

  const [termsTitle, setTermsTitle] = useState("");
  const [termsDesc, setTermsDesc] = useState("");

  const [show, setShow] = useState(false);
  const handleClose = () => {
    setTermsTitle("");
    setShow(false);
  };
  const handleShow = () => setShow(true);
  const [edit, setEdit] = useState(false);

  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState([]);

  const [dataId, setDataId] = useState(false);

  const columns = [
    {
      name: "TITLE",
      cell: (row) => row.title,
    },
    {
      name: "DESC.",
      cell: (row) => row.detailedConditions,
    },
  ];

  const handleSave = () => {
    if (termsTitle === "") {
      toast("Please fill termsTitle ", {
        autoClose: 2000,
      });
      return;
    }

    const data1 = {
      title: termsTitle,
      detailedConditions: termsDesc,
    };

    edit
      ? updateTermsCondition(dataId, data1).then((res) => {
          if (res.success) {
            toast(res.message, {
              autoClose: 2000,
            });
            setTermsTitle("");
            handleClose();
            handleRefresh();
          } else {
            toast(res.message, {
              autoClose: 2000,
            });
            return;
          }
        })
      : addTermsCondition(data1).then((res) => {
          if (res.errorCode === 0) {
            toast(res.message, {
              autoClose: 2000,
            });
            setTermsTitle("");
            handleClose();
            handleRefresh();
          } else {
            toast(res.message, {
              autoClose: 2000,
            });
            return;
          }
        });
  };

  const handleClicked = (id) => {
    termsConditionUUID1(id).then((res) => {
      if (res.errorCode === 0) {
        setTermsTitle(res.responsePacket.title);
        setTermsDesc(res.responsePacket.detailedConditions);
      } else {
        toast(res.message);
      }
    });

    handleShow();
    setEdit(true);
  };

  const handleRefresh = () => {
    var data = {
      page: 0,
      search: "",
      size: -1,
    };

    termsConditionList1(data).then((res) => {
      if (res.errorCode === 0) {
        var temp = res.responsePacket.data;
        setRows(temp);
        setFilteredData(temp);
      } else {
        toast(res.message);
      }
    });
  };

  useEffect(() => {
    var data = {
      page: 0,
      search: "",
      size: -1,
    };

    termsConditionList1(data).then((res) => {
      if (res.errorCode === 0) {
        var temp = res.responsePacket.data;
        setRows(temp);
        setFilteredData(temp);
      } else {
        toast(res.message);
      }
    });
  }, []);

  useEffect(() => {
    const result = rows.filter((data) => {
      return searchForMatch(data.title, search);
    });
    setFilteredData(result);
  }, [search]);

  return (
    <>
      {/* <div className="column list-column d-print-none column-small">
        <PreferencesNav />
      </div> */}
      <div className="column content-column">
        <div className="header clearfix" style={{ borderBottom: "none" }}>
          <span className="float-left" style={{ fontSize: "35px" }}>
            Terms and Condition List
          </span>
        </div>

        <Modal show={show} onHide={handleClose} size="lg">
          <Modal.Body>
            <Header>Terms and Condition Info</Header>
            <br />
            <hr />

            <table>
              <tr>
                <td>Terms:</td>
                <td>
                  {" "}
                  <div>
                    <input
                      autoComplete="off"
                      className="form-control ember-text-area ember-view"
                      onChange={(e) => {
                        setTermsTitle(e.target.value);
                      }}
                      value={termsTitle}
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <td>Desc:</td>
                <td>
                  {" "}
                  <textarea
                    rows="5"
                    cols="100"
                    className="form-control"
                    onChange={(e) => {
                      setTermsDesc(e.target.value);
                    }}
                    value={termsDesc}
                  />
                </td>
              </tr>
            </table>
            <br />
            {/* <div className="form-group col-lg-12">
            <label>Page HTML *</label>
            <CKEditor
              editor={ClassicEditor}
              config={{
                toolbar: {
                  items: [
                    "heading",
                    "|",
                    "bold",
                    "italic",
                    "link",
                    "bulletedList",
                    "numberedList",
                    "|",
                    "indent",
                    "outdent",
                    "|",
                    "imageUpload",
                    "blockQuote",
                    "mediaEmbed",
                    "undo",
                    "redo",
                  ],
                },
              }}
              data={termsDesc}
              onReady={(editor) => {
                // You can store the "editor" and use when it is needed.
              }}
              onChange={(event, editor) => {
                const data = editor.getData();
                setTermsDesc(data);
              }}
              onBlur={(event, editor) => {
              }}
              onFocus={(event, editor) => {
              }}
            />
          </div> */}
          </Modal.Body>

          <Modal.Footer>
            <Button variant="primary" onClick={handleSave}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>
        <div style={{ height: 500, width: "100%" }}>
          <DataTable
            columns={columns}
            data={filteredData}
            fixedHeader
            pointerOnHover={true}
            highlightOnHover={true}
            onRowClicked={(data) => {
              setDataId(data.recordId);
              handleClicked(data.recordId);
            }}
            subHeader
            subHeaderComponent={
              <div className="d-flex align-items-center">
                <div className="input-group mr-2 paginationSearchInput">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      <SearchRoundedIcon />
                    </span>
                  </div>
                  <input
                    autoComplete="off"
                    className="form-control"
                    type="text"
                    placeholder={"Search here"}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
                <button
                  id="ember5839"
                  className="tooltip-container ember-view btn btn-primary d-flex align-items-center"
                  type="button"
                  onClick={handleShow}
                >
                  <AddIcon />
                  New
                </button>
              </div>
            }
          />
        </div>
      </div>
      <Toaster />
    </>
  );
};

export default TermsConditionList;
